import FF from "@/components/forms/FormField.module.css";
import { cn } from "@/utils/classNames.ts";
import type { ReactNode } from "react";
import { Radio } from "react-aria-components";

export interface WRadioProps {
    value: string;
    badge?: ReactNode;
    description: ReactNode;
    isDisabled?: boolean;
    className?: string;
}

export function WRadio({ value, badge, description, isDisabled, className }: WRadioProps) {
    return (
        <Radio value={value} isDisabled={isDisabled} className={cn(FF.FormFieldIconRadio, className)}>
            <div className="flex flex-col items-center gap-1">
                {badge}
                <div className="font-size-small">{description}</div>
            </div>
        </Radio>
    );
}
